import { getEnv } from 'configs/env';
import { NumberUtils, Table } from 'modules';
import React, { FC, useEffect, useState } from 'react';
import { AdminService } from 'services/admin';

import { PopupWraper } from '../popup';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function selects(obj: any, keys: any[]) {
  return keys.reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
}

export function flatTreeData(input: any[]) {
  try {
    const output = [];

    const getChildren = (obj: any) => {
      if (obj && obj.children && obj.children.length > 0) {
        const { children } = obj;

        children.map((item: any) => {
          output.push({ ...item });
          getChildren(item);
          return item;
        });
      }
    };

    output.push(input);
    getChildren(input);

    output.map((item: any) => {
      delete item.children;
      return item;
    });

    return output;
  } catch (error) {
    return [];
  }
}

export const TreeView: FC<{
  affiliate: any[];
  onGetTree: (id: any) => void;
  openPopupMoveBranh: (nodeData: any) => void;
}> = (props) => {
  const [affiliation, setAffiliation] = useState(null as any);
  const [sponsorUserId, setSponsorUserId] = useState<any>(null);

  useEffect(() => setTree(), []);

  const setTree = () => {
    const OrgChart: any = window ? (window as any).OrgChart : undefined;

    if (OrgChart) {
      const { affiliate, onGetTree } = props;
      setAffiliation(affiliate);

      const data = affiliate.map((item: any) => {
        const email = item.email;
        const level = item.rank;
        const img = `/assets/images/rank/rank_${item.rank}.png`;
        // let fullname = item.firstName.toUpperCase() + ' ' + item.lastName.toUpperCase();
        const fullname = item.firstName + ' ' + item.lastName;

        return {
          // ...selects(item, ['email', 'parentId', 'level', 'volume', 'numberOfF1Agency', 'volumeAllBranch']),
          id: item.userId,
          pid: item.presenterId,
          'Display name': fullname,
          Email: email,
          Level: level,
          'Total Balance': 'unknown',
          'Personal Bet (Current Week)': 'unknown',
          'Volume of Downlines (Current week)': 'unknown',
          'Cash Back 0.2% (Current week)': 'unknown',
          'Refund (Current week)': 'unknown',
          'Volume of Downlines (Last week)': 'unknown',
          img,
        };
      });

      //[BEGIN] - customize template
      OrgChart.templates.myTemplate = Object.assign(
        {},
        OrgChart.templates.polina,
      );
      OrgChart.templates.myTemplate.node =
        '<rect x="0" y="0" height="60" width="300" fill="#039BE5" stroke-width="1" stroke="#686868" rx="30" ry="30"></rect>';
      OrgChart.templates.myTemplate.size = [300, 60];
      OrgChart.templates.myTemplate.img_0 =
        '<clipPath id="ulaImg">' +
        '<circle cx="20" cy="20" r="35"></circle>' +
        '</clipPath>' +
        '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="8" y="5" width="35" height="45">' +
        '</image>';
      OrgChart.templates.myTemplate.field_0 =
        '<text width="210" class="field_0" style="font-size: 18px;" fill="#ffffff" x="48" y="26" text-anchor="start">{val}</text>';
      OrgChart.templates.myTemplate.field_1 =
        '<text width="210" class="field_1" style="font-size: 14px;" fill="#ffffff" x="48" y="45" text-anchor="start">{val}</text>';
      OrgChart.templates.myTemplate.nodeMenuButton =
        '<g style="cursor:pointer;" transform="matrix(1,0,0,1,270,23)" control-node-menu-id="{id}"><rect x="-4" y="-10" fill="#000000" fill-opacity="0" width="22" height="22"></rect><circle cx="0" cy="0" r="2" fill="#ffffff"></circle><circle cx="0" cy="7" r="2" fill="#ffffff"></circle><circle cx="0" cy="14" r="2" fill="#ffffff"></circle></g>';
      //[END] - customize template

      const treeIcon =
        '<svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17,16l-4-4V8.82a3,3,0,1,0-2,0V12L7,16H3v5H8V17.95l4-4.2,4,4.2V21h5V16Z" transform="translate(-3 -3)" /></svg>';
      const iconMove = `<svg width="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19"><path d="M21.99,8a1.982,1.982,0,0,0-.94-1.7L12,1,2.95,6.3A1.991,1.991,0,0,0,2,8V18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2ZM12,13,3.74,7.84,12,3l8.26,4.84Z" transform="translate(-2 -1)" /></svg>`;
      const chart = new OrgChart(document.getElementById('tree'), {
        template: 'myTemplate',
        enableSearch: false,
        nodeBinding: {
          field_0: 'Display name',
          field_1: 'Email',
          field_2: 'Level',
          field_5: 'Total Balance',
          field_6: 'Personal Bet (Current Week)',
          field_7: 'Volume of Downlines (Current week)',
          field_8: 'Cash Back 0.2% (Current week)',
          field_9: 'Refund (Current week)',
          field_10: 'Volume of Downlines (Last week)',
          img_0: 'img',
        },
        nodeMouseClick: OrgChart.action.none,
        orientation: OrgChart?.orientation?.left,
        collapse: { level: 1, allChildren: true },
        mouseScrool: OrgChart?.action?.ctrlZoom,
        enableKeyNavigation: true,
        levelSeparation: 200, //The gap between each level. Default value - 60
        siblingSeparation: 20, //The gap between nodes in a subtree. Default value - 20
        subtreeSeparation: 40, //The gap between subtrees. Default value - 40
        sticky: true, //Stops the chart locking to the top of the screen once you move it.
        lazyLoading: false,
        nodeMenu: {
          call: {
            text: 'Get tree',
            icon: treeIcon,
            onClick: (nodeId: any) => getTreeHandler(nodeId),
          },
          call2: {
            text: 'Get referral sponsor',
            icon: treeIcon,
            // onClick: (nodeId: any) => handleClickGetReferralSponsor(nodeId),
            onClick: (nodeId: any) => setSponsorUserId(nodeId),
          },
          move: {
            text: 'Move branch',
            icon: iconMove,
            onClick: (nodeId: any) =>
              props.openPopupMoveBranh(chart.get(nodeId)),
          },
        },
        nodes: data,
      });

      chart.on('click', async function (sender: any, args: any) {
        const nodeSender = sender.get(args.node.id);
        const currentNode = chart.config.nodes.find(
          (element: any) => element.id === nodeSender.id,
        );
        await AdminService.getAffiliateDetail(nodeSender.id).then((res) => {
          if (currentNode) {
            chart.updateNode({
              ...currentNode,
              'Total Balance': NumberUtils.toFormatNumber(
                +res?.result?.currentBalande,
                +getEnv('NUMBER_DECIMAL_DISPLAY'),
              ),
              'Personal Bet (Current Week)': NumberUtils.toFormatNumber(
                +res?.result?.volume,
                +getEnv('NUMBER_DECIMAL_DISPLAY'),
              ),
              'Volume of Downlines (Current week)': NumberUtils.toFormatNumber(
                +res?.result?.volumeAllBranch,
                +getEnv('NUMBER_DECIMAL_DISPLAY'),
              ),
              'Cash Back 0.2% (Current week)': NumberUtils.toFormatNumber(
                +res?.result?.cashBack,
                +getEnv('NUMBER_DECIMAL_DISPLAY'),
              ),
              'Refund (Current week)': NumberUtils.toFormatNumber(
                +res?.result?.exGameRefund,
                +getEnv('NUMBER_DECIMAL_DISPLAY'),
              ),
              'Volume of Downlines (Last week)': NumberUtils.toFormatNumber(
                +res?.result?.volumeAllBranchLastWeek,
                +getEnv('NUMBER_DECIMAL_DISPLAY'),
              ),
            });
            sender.editUI.show(nodeSender.id, true);
          }
        });
      });

      const getTreeHandler = (nodeId: any) => {
        const nodeData = chart.get(nodeId);
        onGetTree(nodeData.id);

        // var employeeName = nodeData["name"];
      };
    }

    // eslint-disable-next-line
  };

  if (affiliation) {
    if (affiliation[0].userId != props.affiliate[0].userId) {
      setTree();
      setAffiliation(props.affiliate);
    }
  }

  return (
    <div className='TreeView'>
      <div id='tree' />
      {sponsorUserId != null && (
        <PopupWraper
          center
          title='Referral sponsor'
          onClose={() => setSponsorUserId(null)}
        >
          <Table
            structure={[
              {
                name: 'Email',
                key: 'email',
              },
              {
                name: 'Display Name',
                key: 'firstName',
              },
              {
                name: 'Tier',
                key: 'level',
              },
            ]}
            fetchData={async (params) => {
              return AdminService.getReferralSponsor(sponsorUserId, 0, {
                page: params.pageNumber,
                pageSize: params.limit,
                ...params,
              });
            }}
          />
        </PopupWraper>
      )}
    </div>
  );
};
